import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Status, BUTTON_LOADING_CIRCLE } from 'common/utils/constants';
import CommissionErrorBox from '../CommissionErrorBox/CommissionErrorBox';
import { doTerminateCommissionOp, doDeleteBundle } from 'redux/actions';
import classnames from 'classnames';
import './RasterProgressScreen.css';
import moment from 'moment';
import { SCREEN_INDEXES } from '../utils';

const RasterProgressScreen = (props) => {
  const [fade, setFade] = useState(false);
  let opacity = fade ? '0' : '1';
  const dispatch = useDispatch();

  let totalSeconds = Math.round(120 - (props.commissioningProgress / 100) * 120);
  if (props.commissioningProgress >= 99 && props.customStatus === 'awaiting_activeBeam') {
    totalSeconds = 0;
  }

  const duration = moment.duration(totalSeconds, 'seconds');
  let progString = props.commissioningProgress ? props.commissioningProgress + '%' : '0%';
  let remainingTimeStr = `0${duration.minutes()}:${
    duration.seconds() > 9 ? duration.seconds() : '0' + duration.seconds()
  }`;
  if (props.customStatus === 'awaiting_activeBeam') {
    progString = '100%';
    remainingTimeStr = '00:00';
  }

  let getCommissioningStatusName = props.commissioningId && `GetCommissioningStatus-${props.commissioningId}`;
  let getCommissioningStatus = useSelector(
    (store) => props.commissioningId & store.statuses[getCommissioningStatusName]
  );
  let deleteBundleStatusName = `DeleteBundle-${props.bundleId}`;
  let deleteBundleStatus = useSelector((store) => store.statuses[deleteBundleStatusName]);
  let terminateCommissionOpStatusName = `terminateCommissionOp-${props.commissioningId}`;
  let terminateCommissionOpStatus = useSelector((store) => store.statuses[terminateCommissionOpStatusName]);
  let getRasterInfoStatusName = `getRasterHeatmapInfo-${props.commissioningId}`;
  let getRasterInfoStatus = useSelector((store) => store.statuses[getRasterInfoStatusName]);

  useEffect(() => {}, []);

  const handleCancelCommissioning = () => {
    let cb_success = () => {
      props.clearTimeoutAndInterval();
      props.onClose();
    };
    // delete the newly created bundle along with the props.bundleId
    if (props.bundleId) {
      dispatch(doDeleteBundle(props.bundleId));
    }
    // terminate commissioning op along with the props.commissioningId
    if (props.commissioningId) {
      dispatch(doTerminateCommissionOp(props.commissioningId, cb_success));
    }
  };

  let getRasterInfoErrorBox = null;
  if (getRasterInfoStatus === Status.FAILURE) {
    getRasterInfoErrorBox = (
      <CommissionErrorBox
        onClose={props.onClose}
        title={'Get raster information error'}
        message={'Something went wrong. Please try again later.'}
      />
    );
  }

  let terminateCommissionOpErrorBox = null;
  if (terminateCommissionOpStatus === Status.FAILURE) {
    terminateCommissionOpErrorBox = (
      <CommissionErrorBox
        onClose={props.onClose}
        title={'Terminate commissioning operation error'}
        message={'Something went wrong. Please try again later.'}
      />
    );
  }

  let getCommissioningStatusErrorBox = null;
  let getCommissioningStatusMsg = props.getStatusErrorMsg;
  switch (props.getStatusErrorMsg) {
    case '400':
      getCommissioningStatusMsg = 'The parameters passed in the request body are invalid.';
      break;
    case '403':
      getCommissioningStatusMsg = 'Something went wrong. Please try it again later.';
      break;
    case '404':
      getCommissioningStatusMsg = 'Could not find requested source.';
      break;
    case '405':
      getCommissioningStatusMsg = 'Operation is not supported by device.';
      break;
    case '500':
      getCommissioningStatusMsg = 'There has been an internal error in the server while processing the search request.';
      break;
    default:
      break;
  }

  if (getCommissioningStatus === Status.FAILURE || props.getStatusErrorMsg) {
    getCommissioningStatusErrorBox = (
      <CommissionErrorBox
        onClose={props.onClose}
        title={'Get commissioning status error'}
        message={
          getCommissioningStatusMsg ? getCommissioningStatusMsg : 'Something went wrong. Please try again later.'
        }
      />
    );
  }

  return (
    <div className="RasterProgressScreen_Outer_Container">
      {getRasterInfoErrorBox && getRasterInfoErrorBox}
      {terminateCommissionOpErrorBox && terminateCommissionOpErrorBox}
      {getCommissioningStatusErrorBox && getCommissioningStatusErrorBox}
      <div className="RasterProgressScreen_Inner_Container" style={{ opacity: opacity }}>
        <div className="RasterProgressScreen_Text">Collecting beam information</div>
        <div className="RasterProgressScreen_Progress_Container">
          <div className="RasterProgressScreen_Progress_Outer">
            <div className="RasterProgressScreen_Progress_Inner" style={{ width: progString }} />
            <div className="RasterProgressScreen_Progress_Border" />
          </div>
          <div className="RasterProgressScreen_Progress_Percentage">{progString}</div>
        </div>
        <div className="RasterProgressScreen_Progress_TimeEstimate">Estimated time remaining {remainingTimeStr}</div>
      </div>
      <div className={'RasterProgressScreen_BottomContainer'}>
        <button
          className="RasterProgressScreen_CancelButton"
          disabled={deleteBundleStatus === Status.PENDING || terminateCommissionOpStatus === Status.PENDING}
          onClick={() => {
            // handleCancelCommissioning();
            props.onClose();
          }}
        >
          Cancel
        </button>
        <button
          type="submit"
          className={classnames({
            RasterProgressScreen_NextButton: true,
            RasterProgressScreen_NextButton_Disabled:
              getRasterInfoStatus === Status.PENDING ||
              getRasterInfoStatus === Status.FAILURE ||
              (props.commissioningProgress !== 100 && props.customStatus !== 'awaiting_activeBeam')
          })}
          onClick={() => {
            props.onNext(SCREEN_INDEXES.IN_PROGRESS, null);
          }}
        >
          {getRasterInfoStatus === Status.PENDING ? BUTTON_LOADING_CIRCLE : 'Next'}
        </button>
      </div>
    </div>
  );
};

export default RasterProgressScreen;
